module.exports = __webpack_public_path__ + "static/img/target_1.af670b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/target_1.png
// module id = sjNX
// module chunks = 1